module.exports = "<label class=\"checkbox\"\r\n       [ngClass]=\"{'checkbox--grouped': grouped, 'checkbox--single': single, 'checkbox--disabled': disabled}\">\r\n    <input [(ngModel)]=\"selected\" [disabled]=\"disabled\" (ngModelChange)=\"onChangeCallback(selected)\"\r\n           class=\"checkbox__input\" type=\"checkbox\">\r\n    <span class=\"checkbox__label\" *ngIf=\"label\">{{ label | translate }}</span>\r\n</label>"


//////////////////
// WEBPACK FOOTER
// ./src/components/checkbox/checkbox.component.html
// module id = 29
// module chunks = 0 1